/* global angular, moment */
/**
 * saved by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.sv')
    .component('sveditor', {
      restrict: 'E',
      bindings: {
        sv: '<?',
        svid: '<?'
      },
      template: `
        <svform sv="vm.sv" parentsave="vm.childsave(sv)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Sozialversicherung erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer neuen Sozialversicherung wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Sozialversicherung konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Sv', 'Rlog',
        function ($log, Sv, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;

          vm.$onInit = function () {
            if ((angular.isUndefined(vm.sv) || !vm.sv.hasOwnProperty('_id'))
              && angular.isDefined(vm.svid)) {
              Sv.$find(vm.svid)
                .$then(
                  function (sv) {
                    vm.sv = sv;
                  },
                  function (err) {
                    $log.error('SV not found, id: ', vm.svid, err);
                    Rlog.error('sv', 'sveditor', 'SV not found', {_id: vm.svid});
                  });
            }
          };

          function childsave(sv) {
            // vm.sv = angular.copy(sv);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in sv) {
              if (sv.hasOwnProperty(key)) {
                vm.sv[key] = sv[key];
              }
            }
            vm.save();
          }

          function save() {
            if (vm.sv.$hasPendingActions()) {
              vm.sv.$cancel();
              vm.sv.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of SV failed: ', err);
                Rlog.error('vcutils.sv', 'sveditor', 'Saving of SV failed: ', {error: err, svid: vm.sv._id});
              });
            }
            else {
              vm.sv.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of SV failed: ', err);
                Rlog.error('vcutils.sv', 'sveditor', 'Saving of SV failed: ', {error: err, svid: vm.sv._id});
              });
            }
          }

          function oncancel() {
            vm.canceled = true;
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
